import { CgMail } from "react-icons/cg";

import {
  HStack,
  Heading,
  Box,
  Link,
  Icon,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import {
  AiFillGithub,
  AiFillTwitterCircle,
  AiFillLinkedin,
} from "react-icons/ai";

const About = () => {
  const txtColor1 = useColorModeValue("teal.500", "teal.500");
  const txtColor2 = useColorModeValue("black", "white");

  return (
    <Box mt={{ base: "0px", lg: "0px" }} p={{ base: "15px", lg: "70px" }}>
      <Box
        w={{ base: "100%", lg: "100%" }}
        textAlign={{ base: "center", sm: "center", md: "center" }}
      >
        <Text
          color={txtColor2}
          fontSize={{ base: "20px", lg: "30px" }}
          mt={{ base: "110px", lg: "40px" }}
        >
          Hi, I'm
        </Text>
        <Heading color={txtColor1} fontSize={{ base: "20px", lg: "65px" }}>
          Balogun Sodiq
        </Heading>
        <Heading
          mb="20px"
          fontSize={{ base: "20px", lg: "40px" }}
          color={txtColor2}
        >
          FullStack Developer
        </Heading>

        <Text color={txtColor2}>
          I'm a software developer, specialized in Frontend and Backend of web
          development.
        </Text>
        <Text mt="20px" color={txtColor2}>
          Let's get in touch
        </Text>
        <HStack
          mt="20px"
          justify={{ base: "center", sm: "center", md: "center" }}
          mb={{ base: "50px", lg: "0px" }}
        >
          <Link href="mailto:balosod37@gmail.com" isExternal>
            {" "}
            <Icon
              boxSize={12}
              as={CgMail}
              color={txtColor1}
              _hover={{ color: "teal.800" }}
            />
          </Link>

          <Link href="https://github.com/Balosod" isExternal>
            <Icon
              boxSize={12}
              as={AiFillGithub}
              color={txtColor1}
              _hover={{ color: "teal.800" }}
            />
          </Link>
          <Link href="https://twitter.com/sodiqb86" isExternal>
            <Icon
              boxSize={12}
              as={AiFillTwitterCircle}
              color={txtColor1}
              _hover={{ color: "teal.800" }}
            />
          </Link>

          <Link
            href="https://www.linkedin.com/in/balogun-sodiq-55781921b/"
            isExternal
          >
            <Icon
              boxSize={12}
              as={AiFillLinkedin}
              color={txtColor1}
              _hover={{ color: "teal.800" }}
            />
          </Link>
        </HStack>
      </Box>
    </Box>
  );
};

export default About;
